<template>
  <div class="tax_details">
  <div class="card-panels pt-0">
    <div @click="updateErrorMsg()" class="text-danger text-sm formerrors " v-if="checkProperty($store.state, 'wageReceivedErrMsg') && !loadedFromPreview">
    <vs-alert color="warning"  class="warning-alert reg-warning-alert no-border-radius"  icon-pack="IntakePortal"  icon="IP-information-button"
      active="true">{{ checkProperty($store.state, 'wageReceivedErrMsg') }}
    </vs-alert>
  </div>
  <div class="actions-btn-list actions-btn-listv2" v-if="!loadedFromPreview"> 
    <div></div>
  <ul >
    <li> 
      <span   class="items_edit" @click="updateTaxReturns(true);updateErrorMsg() ">
        <img src="@/assets/images/main/icon-edit.svg" />
        <template  v-if="taxReturnList&&taxReturnList.length > 0">Edit</template>
      <template v-else>Update</template>
      </span>
    </li>
  </ul>
  
  </div>
        <div >
          <div class="accordian-table filingdata_table filingdata_table_v2 pad">
            
            <template  v-if="taxReturnList&&taxReturnList.length > 0">
                <vs-table :data="taxReturnList" class="fees_table padt10 "> 
                  <template slot="thead">
                    <vs-th>
                      Wages Received Year   
                    </vs-th>
                    <vs-th>
                      Salary Received 
                    </vs-th>
                    <vs-th >
                      Documents
                    </vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <vs-tr v-for="taxItem in data" :key="taxItem">
                      <vs-td>
                         {{ checkProperty(taxItem, 'year') }}
                      </vs-td>
                      <vs-td v-if="checkProperty(taxItem, 'salary')">
                        {{formatprice(taxItem.salary)}}
                      </vs-td>
                      <vs-td v-else>
                      {{'-'}}
                      </vs-td>
                      <vs-td>
                        <template>
         <div class="px-6">
          <documentsView @download_or_view="download_or_view" :type="'Cheques'" :documentsList="taxItem['document']" />
         </div>
        </template>
        <div class="missed-date cursor" @click="download_or_view(checkProperty(petition['filingFeeDocs'], 'cheques'))" v-if="false" >
                                      <!-- <span>{{checkProperty( showDetails,'nameNo')}}</span> -->
                                        <docmentType  :title="'name'":item="petition['filingFeeDocs']['cheques']" />
                                    </div>
  
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
            </template>
            <template> 
              <NoDataFound ref="NoDataFoundRef"  v-if="taxReturnList.length == 0 " content="" heading="No Results Found" type='Email' />
            </template>
           
            
          </div>
  
          
  
        </div>
       <w2ActionPopup
       v-if="showTaxReturnPopup"
       :petition="petition"
       @hidePopup="hideTaxReturnModal"/>
        
        
      </div>
    </div>
  </template>
  
  <script>
  import documentsView from "@/views/common/documentsView.vue";
  const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
  });
  
  
  import moment from "moment";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import NoDataFound from "@/views/common/noData.vue";
  import _ from "lodash";
  import docmentType from "@/views/common/docType.vue";
  import FileUpload from "@/views/FileUpload.vue";
  import w2ActionPopup from "../actionpopups/w2ActionPopup.vue";
  export default {
  computed:{
   
  },
  props: {
    loadedFromPreview:false,
     currentRole:null,
     currentUser:null,
    petition: {
      type: Object,
      default: null
    },
    workFlowDetails: {
      type: Object,
      default: null,
    },
  },
  components: {
    documentsView,
    FileUpload,
    VuePerfectScrollbar,
    NoDataFound,
    docmentType,
    w2ActionPopup
  },
  
  watch: {
  },
  methods: {
    updateErrorMsg(){
      this.$store.commit('updateWageReceivedErrMsg','');
    },
    updateTaxReturnsAction(){
  let postData={
    'companyId':this.checkProperty(this.petition,'companyId'),
    //'taxReturnYears':[]
  }
  if(this.checkProperty(this.taxReturnList,'length')>0){
    postData['taxReturnYears']=this.taxReturnList
  }
  let path='company/update-tax-return-years'
  this.taxReturnformerrors=''
   this.submitingTaxReturnsLoading=true
      this.$store.dispatch('commonAction', {"data":postData ,"path":path}).then((response) => {
        this.submitingTaxReturnsLoading=false
        this.showToster({ message: response.message, isError: false });
        this.hideTaxReturnModal()
     
        }).catch((error)=>{
          this.submitingTaxReturnsLoading=false
          this.taxReturnformerrors=error.message
          //this.showToster({ message: response.message, isError: tr });
  
        })
    },
    remove(item, data, filindex) {
         data.splice(filindex, 1);
         this.removeFileFromS3(item)
      },
    hideTaxReturnModal(){
      this.getTaxDetails()
      this.showTaxReturnPopup=false
      //this.$modal.hide('taxReturnsModal')
    },
    
    download_or_view(item){
     // alert();
      this.$emit('download_or_view',item);
    },
      formatprice(amount) {
      return formatter.format(amount);
    },
    updateTaxReturns(action=true) {
      //this.$modal.show('taxReturnsModal')
       this.showTaxReturnPopup=true
  
  
    },
    updateTaxReturnsforPetitioner(){
      this.isPetitionerTaxPopup=true
    }
    ,
    
    getTaxDetails(){
  // let postData={
  //   'companyId':this.checkProperty(this.petition,'companyId')
  // }
  // let path='company/details'
  //     this.$store.dispatch('commonAction', {"data":postData ,"path":path}).then((response) => {
  //         if(this.checkProperty(response,'taxReturnYears','length')>0){
  //            this.taxReturnList=response['taxReturnYears']
  //         }
  //       }).catch((error)=>{
         
  //       })
  let postData = {
                    userId: this.checkProperty(this.petition,'userId'),
                };
                let path = '/beneficiary-profile/get-wage-received-years'
                this.$store.dispatch('commonAction', {'data':postData,'path':path}).then((res)=>{
                    if(res && res['wageReceivedYears'] && this.checkProperty(res, 'wageReceivedYears', 'length')>0){
                        this.taxReturnList = res['wageReceivedYears'];
                    }
                    this.updateLoading(false);
        setTimeout(()=>{
          this.updateLoading(false);
        },10)
                }).catch((err)=>{
                  this.updateLoading(false);
        setTimeout(()=>{
          this.updateLoading(false);
        },10)
                })
                
    }
  },
  data: () => ({
  submitingTaxReturnsLoading:false,
  taxReturnList:[],
  taxReturnformerrors:'',
  showTaxReturnPopup:false
  }),
  mounted() {   
    if(this.loadedFromPreview && this.checkProperty(this.petition, 'wageInformationArray')  && this.checkProperty(this.petition, 'wageInformationArray', 'length')>0){
      this.taxReturnList = this.checkProperty(this.petition, 'wageInformationArray');
      this.updateLoading(false);
      setTimeout(()=>{
        this.updateLoading(false);
      },10)
    }else{
      this.getTaxDetails()
    }
    
  }
  };
  </script>